import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/header";
import CreateBroadcast from "./createBroadcast";
import type { TemplateType, WhatsappTemplate, ValidationValues,EmailSender,SenderDetail, UserIntegration } from "./types";
import moment from "moment";

import "./createWhatsappBroadcast.css";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { includes, removeEmptyValues } from "../../hooks/use-debounce";
import { createBroadCastFun, getCampaignById } from "../../services/broadcast";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

import LeadSelector from "../../components/LeadSelector/LeadSelector";
import DrawerExistModal from "../../components/drawerExistModal";
import { useSelector, useDispatch } from "react-redux";
import { setLeadIds } from "../../actions/actions";

import UnifiedTemplateSelector from "./UnifiedTemplateSelector";
import logger, { Logger } from '../../utils/logger';
import { CampaignPayload, campaignService } from "../../services/campaignService";

interface ExpandedSections {
  [key: string]: boolean;
}

const user_preferences = [
  {
    email: "vivek@smn.com",
    name: "Usender1",
  },
  {
    email: "vivek@abc.com",
    name: "sendre 2",
  },
];

const CreateWhatsappBroadcast: React.FC = () => {
const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [selectedTemplate, setSelectedTemplate] = useState<string>("");
  const [selectedTemplateName, setSelectedTemplateName] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState<any>("WhatsApp");
  const [selectedMail, setSelectedMail] = useState("");
  const [isTemplateOpen, setIsTemplateOpen] = useState<boolean>(false);
  const [expandedSections, setExpandedSections] = useState<ExpandedSections>({
    template: false,
    recipients: false,
    type: false,
  });
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [schedule, setSchedule] = useState(false);
  const [isLead, showIsLead] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [selectedLeadList, setSelectedLeadList] = useState<any>({});
  const [confirmShowExitModal, setConfirmShowExitModal] = useState(false);
  useState<boolean>(false);
  const [senderOptions, setSenderOptions] = useState<SenderDetail[]>([]);
  const [isScheduling, setIsScheduling] = useState<boolean>(false);
  const [actionToConfirm, setActionToConfirm] = useState<string>("");

  const [zeptoMailIntegration, setZeptoMailIntegration] = useState<UserIntegration | null>(null);

const fetchCampaignLeads = async (campaignId: string) => {
  try {
    const { data } = await getCampaignById(campaignId, {
      page: 1,
      perPage: 1000, // Get all leads
    });
    
    if (data.data && data.data.leads) {
      const leadIds = data.data.leads.map((lead: any) => lead._id);
      validation.setFieldValue("leads", leadIds);
      validation.setFieldValue("dailyLimit", leadIds.length);
      
      // Also store in redux if needed
      if (leadIds.length > 0) {
        dispatch(setLeadIds(leadIds));
      }
      
      logger.log('✅ Copied campaign leads:', leadIds.length);
    }
  } catch (error) {
    logger.error('❌ Error fetching campaign leads:', error);
    // Fallback to normal lead selection if fetch fails
    setCurrentStep(1);
  }
};

  const { selectedLeadIds }: { selectedLeadIds: string[] } = useSelector(
    (state: any) => state.rootReducers.leads
  );

  Logger.log("senderOptions", senderOptions);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      if (selectedLeadIds?.length) {
        dispatch(setLeadIds([]));
      }
    };
  }, []);


  useEffect(() => {
    if (selectedLeadIds?.length) {
      validation.setFieldValue("leads", selectedLeadIds);
      // Set dailyLimit to match the number of recipients
      validation.setFieldValue("dailyLimit", selectedLeadIds.length);
    }
  }, [selectedLeadIds]);

  useEffect(() => {
    if (selectedLeadIds?.length) {
      validation.setFieldValue("leads", selectedLeadIds);
    }

    return () => {
      if (selectedLeadIds?.length) {
        dispatch(setLeadIds([]));
      }
    };
  }, [selectedLeadIds]);



useEffect(() => {
  // Handle copied campaign data
  const copiedCampaignData = localStorage.getItem('copiedCampaignData');
  if (copiedCampaignData) {
    const copyData = JSON.parse(copiedCampaignData);
    
// Set basic campaign data
validation.setFieldValue("name", copyData.name);
setSelectedOption(copyData.serviceType === 'whatsapp' ? 'WhatsApp' : 'Email');
validation.setFieldValue("serviceType", copyData.serviceType);

// Set sender details for email campaigns
if (copyData.senderDetail && copyData.serviceType !== 'whatsapp') {
  validation.setFieldValue("senderDetail", {
    email: copyData.senderDetail.email,
    name: copyData.senderDetail.name,
    service: copyData.senderDetail.service || copyData.serviceType
  });
  logger.log('📧 Set sender details:', copyData.senderDetail);
}
    
    // Fetch leads from original campaign and set them
    if (copyData.originalCampaignId) {
      fetchCampaignLeads(copyData.originalCampaignId);
    }
    
    // Set daily limit if applicable
    if (copyData.dailyLimit) {
      validation.setFieldValue("dailyLimit", copyData.dailyLimit);
    }

    // Set email verification flag if applicable
    if (copyData.isEmailVerificationEnabled !== undefined) {
      validation.setFieldValue("isEmailVerificationEnabled", copyData.isEmailVerificationEnabled);
    }
    
 // Skip to template selection step, but check if email needs sender first
if (copyData.serviceType !== 'whatsapp' && !copyData.senderDetail) {
  // Email campaign but no sender details - stay at step 1
  setCurrentStep(1);
  logger.log('📧 Email campaign without sender - staying at step 1');
} else {
  // Either WhatsApp or Email with sender - go to template step
  setCurrentStep(2);
  logger.log('✅ Going to template step');
}
    
    // Clear the copied data
    localStorage.removeItem('copiedCampaignData');
    return;
  }

  // Handle leads selected from existing campaign view
  const selectedLeadsFromCampaign = localStorage.getItem('selectedCampaignLeads');
  if (selectedLeadsFromCampaign) {
    const parsedLeads = JSON.parse(selectedLeadsFromCampaign);
    if (parsedLeads.length > 0) {
      validation.setFieldValue("leads", parsedLeads);
      localStorage.removeItem('selectedCampaignLeads'); // Clear after using
    }
  }
}, []);

  // NEW: Handle filterParams from navigation state (filter mode)
  useEffect(() => {
    const navState = location.state as { filterParams?: any; leadCount?: number };

    if (navState?.filterParams) {
      const leadCount = navState.leadCount || 0;

      logger.log('🎯 Campaign creation with filterParams:', {
        filterParams: navState.filterParams,
        expectedCount: leadCount
      });

      // Store filterParams in validation for later use during submission
      validation.setFieldValue("filterParams", navState.filterParams);
      validation.setFieldValue("dailyLimit", leadCount);

      // Create a placeholder leads array to show the count in UI
      // Backend will use filterParams, not these placeholder IDs
      const placeholderLeads = Array(leadCount).fill('filter-placeholder');
      validation.setFieldValue("leads", placeholderLeads);

      logger.log(`📊 Created ${leadCount} placeholder leads for UI display`);

      // Clear the navigation state to prevent re-triggering
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      
      // Get existing mail senders from preferences for gmail and brevo
      const mailSender = userData?.userPreference?.mailSender || {
        gmail: [],
        brevo: []
      };
      
      // Check for ZeptoMail integration in the user's integrations
      const userIntegrations: UserIntegration[] = userData?.userIntegrations || [];
      
      logger.log("Checking for ZeptoMail integration:", userIntegrations);
      
      const zeptoMailIntegration = userIntegrations.find((int: UserIntegration) => 
        int.integration?.key === 'zeptomail' && 
        int.isActive === true && 
        int.isDeleted === false
      );
      
      logger.log("Found ZeptoMail integration:", zeptoMailIntegration);
      
      const foundIntegration = userIntegrations.find((int: UserIntegration) => 
        int.integration?.key === 'zeptomail' && 
        int.isActive === true && 
        int.isDeleted === false
      );
      
      setZeptoMailIntegration(foundIntegration || null);
      
      // Create the base senders array with gmail and brevo
      let allSenders: SenderDetail[] = [
        ...mailSender.gmail.map((sender: SenderDetail) => ({ ...sender, service: 'gmail' as const })),
        ...mailSender.brevo.map((sender: SenderDetail) => ({ ...sender, service: 'brevo' as const }))
      ];
      
      // If ZeptoMail integration exists, add it to the senders list
      if (zeptoMailIntegration) {
        // Get details from the integration
        const senders = zeptoMailIntegration.details?.senders || [];
        const defaultSender = senders.length > 0 ? senders[0] : null;
        
        const zeptoSender: SenderDetail = {
          _id: zeptoMailIntegration._id,
          email: defaultSender?.email || 'noreply@yourdomain.com',
          name: defaultSender?.name || zeptoMailIntegration.integration.name || 'ZeptoMail',
          service: 'zeptomail'
        };
        
        logger.log("Adding ZeptoMail sender:", zeptoSender);
        
        // Add ZeptoMail sender to the list
        allSenders.push(zeptoSender);
      }
      
      logger.log("All available senders:", allSenders);
      
      // Set the available sender options
      setSenderOptions(allSenders);
    }
  }, []);

  const STEPS = {
    CAMPAIGN_DETAILS: 1, // Combined Type & Info
    TEMPLATE: 2, // Template selection
    RECIPIENTS: 3, // Recipients selection
    SCHEDULE: 4, // Schedule & Send
  };

  // Progress Indicator Component (same as before)
  const ProgressIndicator = () => {
    const steps = [
      { step: 1, label: "Campaign Details" },
      { step: 2, label: "Template" },
      { step: 3, label: "Recipients" },
      { step: 4, label: "Schedule" },
    ];

    return (
      <div className="blockArea progress-area">
        <div className="progress-steps-container">
          {steps.map(({ step, label }, index) => (
            <div key={step} className="d-flex align-items-center progress-step">
              {/* Circle with number/check */}
              <div
                onClick={() => {
                  if (isStepComplete(step) || step < currentStep) {
                    setCurrentStep(step);
                  }
                }}
                className={`progress-number font-gilroy-bold
                  ${currentStep === step ? "active" : ""}
                  ${currentStep > step ? "completed" : ""}
                `}
              >
                {currentStep > step ? (
                  <i className="ri-check-line"></i>
                ) : (
                  <span>{step}</span>
                )}
              </div>

              {/* Label */}
              <span
                className={`progress-text font-gilroy-medium 
                ${currentStep === step ? "active" : ""}`}
              >
                {label}
              </span>

              {/* Connector line - except for last item */}
              {index < steps.length - 1 && (
                <div className="progress-line">
                  <div
                    className={`line-inner ${
                      currentStep > step + 1
                        ? "completed"
                        : currentStep > step
                        ? "active"
                        : ""
                    }`}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Function to check if a step is complete
  const isStepComplete = (step: number) => {
    switch (step) {
      case STEPS.CAMPAIGN_DETAILS:
        // Check if serviceType is an email service (gmail, brevo, zeptomail)
        const isEmailService = ["gmail", "brevo", "zeptomail"].includes(validation.values.serviceType);
        return (
          !!validation.values.serviceType &&
          !!validation.values.name &&
          (!isEmailService ||
            (validation.values.senderDetail?.email &&
              validation.values.senderDetail?.name))
        );

      case STEPS.TEMPLATE:
        // Check if serviceType is an email service
        const isEmail = ["gmail", "brevo", "zeptomail"].includes(validation.values.serviceType);
        return isEmail
          ? !!validation.values.emailTemplate
          : !!validation.values.whatsappTemplate;

      case STEPS.RECIPIENTS:
        return validation.values.leads && validation.values.leads.length > 0;

      case STEPS.SCHEDULE:
        return true; // Always allow final step

      default:
        return false;
    }
  };

  const toggleSection = (sectionId: string) => {
    logger.log(`🔘 Toggling section: ${sectionId}, current state:`, expandedSections);
    if (sectionId === "template") {
      setIsTemplateOpen(true);
    } else {
      setExpandedSections((prevState) => {
        const newState = {
          ...prevState,
          [sectionId]: !prevState[sectionId],
        };
        logger.log(`✅ New expanded state:`, newState);
        return newState;
      });
    }
  };

  const handleTemplateClick = () => {
    setIsTemplateOpen(true);
  };

  const handleOptionSelect = (option: string) => {
    logger.log(`🔄 Changing campaign type from "${selectedOption}" to "${option}"`);

    // Update UI state first
    setSelectedOption(option);

    if (option === "Email") {
      logger.log("📧 Switching to Email mode - clearing fields");
      // Reset sender details when switching to Email
      validation.setFieldValue("senderDetail", {
        email: "",
        name: "",
        service: undefined
      });
      validation.setFieldValue("serviceType", "");
      // Clear WhatsApp-specific fields
      validation.setFieldValue("whatsappTemplate", "");
    } else {
      logger.log("💬 Switching to WhatsApp mode - clearing fields");
      // For WhatsApp, set service type directly and clear Email-specific fields
      validation.setFieldValue("serviceType", option.toLowerCase());
      validation.setFieldValue("senderDetail", {
        email: "",
        name: "",
        service: undefined
      });
      validation.setFieldValue("emailTemplate", "");
      validation.setFieldValue("dailyLimit", 0);
      validation.setFieldValue("isEmailVerificationEnabled", false);
    }

    // Clear template selection UI states
    setSelectedTemplate("");
    setSelectedTemplateName("");

    logger.log(`✅ Campaign type changed to: ${option}`);
  };

  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setExpandedSections((prev) => ({
        ...prev,
        type: false,
        sender: false,
      }));
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSchedule = () => {
    setSchedule(true);
  };

  // Unified template select handler
const handleUnifiedTemplateSelect = (template: any) => {
  // Determine template type based on structure
  const isEmailTemplate = template.details || template.body;
  
  if (isEmailTemplate) {
    // Handle email template
    setSelectedTemplate(template._id);
    setSelectedTemplateName(template.details?.title || template.name);
    validation.setFieldValue("emailTemplate", template._id);
  } else {
    // Handle WhatsApp template
    validation.setFieldValue("whatsappTemplate", template._id);
    setSelectedTemplate(template._id);
    setSelectedTemplateName(template.name);
  }
  
  setExpandedSections({ ...expandedSections, template: false });
};

const handleSubmit = async (values: any) => {
  try {
    setLoading(true);
    
    logger.log("Form values before submission:", values);

    // Create base payload
    const payload: CampaignPayload = {
      name: values.name,
      serviceType: validation.values.serviceType,
      scheduleAt: values.scheduleAt ? moment(values.scheduleAt).utc().format() : new Date(),
    };

    // NEW: Handle filterParams mode vs manual lead selection
    if (values.filterParams) {
      // Filter mode: Send filterParams, not the placeholder leads array
      payload.filterParams = values.filterParams;
      logger.log("📊 Campaign with filterParams (backend will fetch leads):", {
        filterParams: payload.filterParams,
        leadCount: values.leads?.length // Just for logging
      });
    } else {
      // Manual mode: Send actual lead IDs
      payload.leads = values.leads;
      logger.log("📋 Campaign with manual lead selection:", {
        leadCount: values.leads?.length
      });
    }
    
    // Add template or content based on service type
    if (values.serviceType === "whatsapp") {
      payload.whatsappTemplate = values.whatsappTemplate;
      // 📱 WhatsApp: Explicitly ensure no sender details
      logger.log("🚫 WhatsApp campaign - excluding sender details");
    } else if (["gmail", "brevo", "zeptomail"].includes(values.serviceType)) {
      payload.content = values.emailTemplate;
      
      // 📧 Email services: Add sender details
      if (values.senderDetail) {
        payload.senderDetail = {
          email: values.senderDetail.email,
          name: values.senderDetail.name
        };
        logger.log("✅ Email campaign - including sender details:", payload.senderDetail);
      }
      
      // Add daily limit for gmail and zeptomail
      if (["gmail", "zeptomail"].includes(values.serviceType)) {
        payload.dailyLimit = (values.dailyLimit <= 0 || values.dailyLimit >= values.leads.length)
          ? values.leads.length
          : values.dailyLimit;
      }

      // Add email verification flag for email campaigns
      payload.isEmailVerificationEnabled = values.isEmailVerificationEnabled;

      // If it's zeptomail, add integration ID
      if (values.serviceType === "zeptomail" && values.senderDetail?._id) {
        payload.integrationId = values.senderDetail._id;
        logger.log("Adding ZeptoMail integrationId:", values.senderDetail._id);
      }
    }
    
    // 🧹 Clean payload: Remove any undefined/null sender details for WhatsApp
    const cleanPayload = removeEmptyValues(payload) as CampaignPayload;
    
    // 🚫 Double-check: Force remove email-specific fields for WhatsApp
    if (values.serviceType === "whatsapp") {
      delete cleanPayload.senderDetail;
      delete cleanPayload.integrationId;
      delete cleanPayload.dailyLimit;
      delete cleanPayload.isEmailVerificationEnabled;
      logger.log("🧹 Cleaned WhatsApp payload - removed email-specific fields");
    }
    
    logger.log("Final payload for API call:", cleanPayload);
    Logger.log("Final payload for API call:", cleanPayload);
    
    // Use the campaignService instead of createBroadCastFun
    await campaignService.createCampaign(cleanPayload);

    if (selectedLeadIds?.length) {
      dispatch(setLeadIds([]));
    }

    navigate("/whatsappBroadcast", { state: { refresh: true } });
  } catch (error) {
    logger.error("Error creating campaign:", error);
    Logger.log(error);
  } finally {
    setLoading(false);
  }
};

  const getValidationSchema = (selectedOption: string, serviceType?: string) => {
    if (selectedOption === "Email") {
      const baseSchema = {
        name: Yup.string().required("Please enter campaign name"),
        senderDetail: Yup.object({
          email: Yup.string().required("Please enter Sender"),
        }),
        serviceType: Yup.string().required("Please enter serviceType"),
        scheduleAt: Yup.string().when([], {
          is: () => isScheduling,
          then: Yup.string().required("Please select a schedule date and time"),
          otherwise: Yup.string(),
        }),
        emailTemplate: Yup.string().required("Please select Template"),
        // NEW: Make leads optional if filterParams exists
        leads: Yup.array().when('filterParams', {
          is: (filterParams: any) => !filterParams,
          then: Yup.array().min(1).required("Please select leads"),
          otherwise: Yup.array(),
        }),
      };
      
      // Check serviceType passed as parameter instead of accessing validation
      if (serviceType && ["gmail", "zeptomail"].includes(serviceType)) {
        return Yup.object({
          ...baseSchema,
          dailyLimit: Yup.number()
            .min(0, "Daily limit must be a positive number or zero")
            .test(
              "max-recipients",
              "Daily limit cannot exceed the total number of recipients",
              function(value) {
                return !value || value <= this.parent.leads.length;
              }
            ),
        });
      }
      
      return Yup.object(baseSchema);
    } else {
      return Yup.object({
        name: Yup.string().required("Please enter campaign name"),
        serviceType: Yup.string().required("Please enter serviceType"),
        scheduleAt: Yup.string().when([], {
          is: () => isScheduling,
          then: Yup.string().required("Please select a schedule date and time"),
          otherwise: Yup.string(),
        }),
        whatsappTemplate: Yup.string().required("Please select Template"),
        // NEW: Make leads optional if filterParams exists
        leads: Yup.array().when('filterParams', {
          is: (filterParams: any) => !filterParams,
          then: Yup.array().min(1).required("Please select leads"),
          otherwise: Yup.array(),
        }),
      });
    }
  };

  useEffect(() => {
    validation.setErrors({});
    validation.setTouched({});
    validation.setFieldValue("whatsappTemplate", "");
    validation.setFieldValue("emailTemplate", "");
    setSelectedTemplate("");
    setSelectedTemplateName("");
    setIsScheduling(false);
    setActionToConfirm("");
  }, [selectedOption]);

  
  const validation: any = useFormik({
    initialValues: {
      name: "",
      senderDetail: {
        email: "",
        name: "",
      },
      serviceType: "whatsapp",
      scheduleAt: "",
      whatsappTemplate: "",
      emailTemplate: "",
      leads: [],
      dailyLimit: 0, // Add daily limit field
      isEmailVerificationEnabled: false
    },
    validationSchema: getValidationSchema(selectedOption),
    onSubmit: (values) => handleSubmit(values),
  });

  
  // Add this useEffect to update dailyLimit when leads change
useEffect(() => {
  if (validation.values.leads?.length > 0) {
    // Set dailyLimit to match the number of recipients (send all at once by default)
    validation.setFieldValue("dailyLimit", validation.values.leads.length);
  }
}, [validation.values.leads]);

  const handleRecipientsSelected = (value: any) => {
    if (includes(validation.values.leads, value)) {
      const newArray = validation.values.leads.filter(
        (item: string) => item !== value
      );
      validation.setFieldValue("leads", newArray);
      setExpandedSections({ ...expandedSections, recipients: false });
    } else {
      validation.setFieldValue("leads", [...validation.values.leads, value]);
    }
  };

  const handleTemplateSelect = (template: WhatsappTemplate) => {
    Logger.log("Selected Template Object:", template); // Debugging
    if (selectedOption === "WhatsApp") {
      validation.setFieldValue("whatsappTemplate", template._id);
      setSelectedTemplate(template._id); // Set selectedTemplate state
      setSelectedTemplateName(template.name); // Set selectedTemplateName state
      Logger.log("Selected Template ID:", template._id); // Debugging
      Logger.log("Selected Template Name:", template.name); // Debugging
    } else {
      validation.setFieldValue("emailTemplate", template._id);
      setSelectedTemplate(template._id); // For email
      setSelectedTemplateName(template.name); // For email
      Logger.log("Selected Template ID:", template._id); // Debugging
      Logger.log("Selected Template Name:", template.name); // Debugging
    }
  };

  const handleEmailTemplateSelect = (template: TemplateType) => {
    setSelectedTemplate(template._id);
    setSelectedTemplateName(template.details?.title || template.name);
    validation.setFieldValue("emailTemplate", template._id);
    setExpandedSections({ ...expandedSections, template: false });
    Logger.log("Selected Email Template ID:", template._id); // Debugging
    Logger.log(
      "Selected Email Template Name:",
      template.details?.title || template.name
    ); // Debugging
  };

  const handleSelectAll = (value: string[]) => {
    validation.setFieldValue("leads", value);
  };

  const handleDiscard = () => {
    setExpandedSections({ ...expandedSections, template: false });
    validation.setFieldValue("whatsappTemplate", "");
    setSelectedTemplate("");
    setSelectedTemplateName("");
  };

  const handleDiscardEmail = () => {
    setExpandedSections({ ...expandedSections, template: false });
    validation.setFieldValue("emailTemplate", "");
    setSelectedTemplate("");
    setSelectedTemplateName("");
  };

  const handleDiscardRecipients = () => {
    setExpandedSections({ ...expandedSections, recipients: false });
    validation.setFieldValue("leads", []);
  };

  const handleSenderSelect = (sender: SenderDetail) => {
    validation.setValues({
      ...validation.values,
      senderDetail: {
        email: sender.email,
        name: sender.name,
        service: sender.service
      },
      // Crucially, set serviceType to the sender's service
      serviceType: sender.service
    });
  };

  const toggleConfirmEditModal = () => {
    setConfirmShowExitModal(!confirmShowExitModal);
  };

  const handleConfirmDrawerClick = async () => {
    toggleConfirmEditModal(); // Close the modal
  
    if (actionToConfirm === "discard") {
      // Reset form to initial state
      validation.resetForm();
      
      // Reset all states
      setSelectedTemplate("");
      setSelectedTemplateName("");
      setSelectedOption("WhatsApp");
      setExpandedSections({
        template: false,
        recipients: false,
        type: false,
      });
      setCurrentStep(1);
      setIsScheduling(false);

      // Navigate back to the broadcast list
      navigate("/whatsappBroadcast", { state: { refresh: true } });
    } else if (actionToConfirm === "sendNow") {
      // Existing sendNow logic
      validation.setFieldValue("scheduleAt", new Date().toISOString());
      validation.handleSubmit();
    } else if (actionToConfirm === "schedule") {
      // Existing schedule logic
      validation.handleSubmit();
    }
  };

  
  const isFormComplete = (values: ValidationValues): boolean => {
    Logger.log('Validation Check - Current Values:', {
      name: values.name?.trim(),
      serviceType: values.serviceType,
      leadsCount: values.leads?.length,
      whatsappTemplate: values.whatsappTemplate,
      emailTemplate: values.emailTemplate,
      senderEmail: values.senderDetail?.email
    });
  
    // Check for required fields
    if (!values.name?.trim()) {
      Logger.log('Validation failed: Missing campaign name');
      return false;
    }
  
    if (!values.leads?.length) {
      Logger.log('Validation failed: No recipients selected');
      return false;
    }
  
    // Normalize service type for comparison
    const normalizedServiceType = values.serviceType?.toUpperCase();
  
    // WhatsApp campaign validation
    if (normalizedServiceType === 'WHATSAPP') {
      if (!values.whatsappTemplate) {
        Logger.log('Validation failed: Missing WhatsApp template');
        return false;
      }
    }
  
    // Email campaign validation
    if (normalizedServiceType === 'EMAIL') {
      if (!values.emailTemplate) {
        Logger.log('Validation failed: Missing email template');
        return false;
      }
      if (!values.senderDetail?.email?.trim()) {
        Logger.log('Validation failed: Missing sender email');
        return false;
      }
    }
  
    Logger.log('Form validation passed');
    return true;
  };

useEffect(() => {
  Logger.log('Form values changed:', validation.values);
  Logger.log('Form completion status:', isFormComplete(validation.values));
}, [validation.values]);

  return (
    <>
      <div id="main" className="main">
        <Header />
        <div className="createWhatsapp-broadcast">
          {/* Header Section */}
          <section className="auto-section-1 px-0">
            <div className="d-flex align-items-center">
              <div className="align-items-center auto-section-1-sub-1">
                <label>Create new campaign</label>
              </div>
              <span
                onClick={() => {
                  navigate("/whatsappBroadcast");
                }}
                className="ms-auto cursor-pointer"
              >
                <i className="ri-close-line fs-3"></i>
              </span>
            </div>
          </section>

          {/* Progress Indicator */}
          <ProgressIndicator />

          {/* Step 1: Campaign Details */}
          {currentStep === STEPS.CAMPAIGN_DETAILS && (
            <>
              {/* Campaign Type Selection */}
              <div className="blockArea">
                <div className="row align-items-center">
                  <div className="col-5">
                    <div className="d-flex align-items-center">
                      <img src="./assets/img/verified.png" alt="Verified" />
                      Campaign Type
                    </div>
                  </div>
                  <div className="col-7">
                    <div
                      className="fakeDropdown"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSection("type");
                      }}
                      style={{
                        display: "flex",
                        fontSize: "18px",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      <label style={{ cursor: "pointer" }}>
                        {selectedOption
                          ? selectedOption
                          : "Select Campaign Type"}
                      </label>
                      <i
                        className={`fs-4 ri-arrow-${
                          expandedSections["type"] ? "up" : "down"
                        }-circle-line`}
                      ></i>
                      {expandedSections["type"] && (
                        <div
                          style={{
                            position: "absolute",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            padding: "10px",
                            zIndex: 9999,
                            width: "100%",
                            top: "100%",
                            left: 0,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            className="dropdown-item"
                            style={{ cursor: "pointer", padding: "8px", background: "#f0f0f0", marginBottom: "5px" }}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              logger.log("🖱️ WhatsApp MOUSEDOWN");
                              logger.log("🖱️ WhatsApp MOUSEDOWN");
                              handleOptionSelect("WhatsApp");
                              setExpandedSections({ ...expandedSections, type: false });
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              logger.log("🖱️ WhatsApp CLICKED");
                              logger.log("🖱️ WhatsApp CLICKED");
                            }}
                          >
                            <span className="dropdown-item-email">
                              WhatsApp
                            </span>
                          </div>
                          <div
                            className="dropdown-item"
                            style={{ cursor: "pointer", padding: "8px", background: "#f0f0f0" }}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              logger.log("🖱️ Email MOUSEDOWN");
                              logger.log("🖱️ Email MOUSEDOWN");
                              handleOptionSelect("Email");
                              setExpandedSections({ ...expandedSections, type: false });
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              logger.log("🖱️ Email CLICKED");
                              logger.log("🖱️ Email CLICKED");
                            }}
                          >
                            <span className="dropdown-item-email">Email</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Campaign Name */}
              <div className="blockArea mt-3">
                <div className="row align-items-center">
                  <div className="col-5">
                    <div className="d-flex align-items-center">
                      {validation.values.name ? (
                        <img src="./assets/img/verified.png" alt="Verified" />
                      ) : (
                        <img
                          src="./assets/img/grey-ring.png"
                          alt="Not Verified"
                        />
                      )}
                      Campaign name
                    </div>
                  </div>
                  <div className="col-7">
                    <input
                      type="text"
                      placeholder="Enter broadcast name"
                      name="name"
                      value={validation.values.name}
                      onChange={validation.handleChange}
                    />
                  </div>
                </div>
              </div>
              {validation.touched.name && validation.errors.name && (
                <span className="text-danger">{validation.errors.name}</span>
              )}

             {/* Email Sender Selection */}
{selectedOption === "Email" && (
  <div className="blockArea mt-3">
    <div className="row align-items-center">
      <div className="col-5">
        <div className="d-flex align-items-center">
          {validation.values.senderDetail &&
          validation.values.senderDetail.email ? (
            <img src="./assets/img/verified.png" alt="Verified" />
          ) : (
            <img
              src="./assets/img/grey-ring.png"
              alt="Not Verified"
            />
          )}
          Select Sender
        </div>
      </div>
      <div className="col-7">
        <div
          className="fakeDropdown"
          ref={dropdownRef}
          onClick={() => toggleSection("sender")}
          style={{
            display: "flex",
            fontSize: "18px",
            position: "relative",
          }}
        >
          <label>
            {validation.values.senderDetail &&
            validation.values.senderDetail.email ? (
              <>{validation.values.senderDetail.email}</>
            ) : (
              <>Select Sender</>
            )}
          </label>
          <i
            className={`fs-4 ri-arrow-${
              expandedSections["sender"] ? "up" : "down"
            }-circle-line`}
          ></i>
          {expandedSections["sender"] && (
            <div
              style={{
                position: "absolute",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                padding: "10px",
                zIndex: 1000,
                width: "100%",
                bottom: "100%",
                left: 0,
                maxHeight: "300px",
                overflowY: "auto",
                boxShadow: "0 -2px 5px rgba(0,0,0,0.1)"
              }}
            >
              <>
                {/* Gmail Section */}
                {senderOptions.filter(sender => sender.service === 'gmail').length > 0 && (
                  <>
                    <div style={{ padding: "5px", backgroundColor: "#f5f5f5", marginBottom: "5px" }}>
                      Gmail Senders
                    </div>
                    {senderOptions
                      .filter((sender: SenderDetail) => sender.service === 'gmail')
                      .map((sender: SenderDetail) => (
                        <div
                          key={sender._id}
                          className="dropdown-item"
                          onClick={() => handleSenderSelect(sender)}
                        >
                          <span className="dropdown-item-email">
                            {sender.email} ({sender.name})
                          </span>
                        </div>
                      ))}
                  </>
                )}
                
                {/* Brevo Section */}
                {senderOptions.filter(sender => sender.service === 'brevo').length > 0 && (
                  <>
                    <div style={{ padding: "5px", backgroundColor: "#f5f5f5", marginTop: "10px", marginBottom: "5px" }}>
                      Brevo Senders
                    </div>
                    {senderOptions
                      .filter(sender => sender.service === 'brevo')
                      .map((sender) => (
                        <div
                          key={sender._id}
                          className="dropdown-item"
                          onClick={() => handleSenderSelect(sender)}
                        >
                          <span className="dropdown-item-email">
                            {sender.email} ({sender.name})
                          </span>
                        </div>
                      ))}
                  </>
                )}
                
                
                {/* Zeptomail Section */}
<div style={{ padding: "5px", backgroundColor: "#f5f5f5", marginTop: "10px", marginBottom: "5px" }}>
  Zeptomail
</div>
{zeptoMailIntegration && zeptoMailIntegration.details && zeptoMailIntegration.details.senders && 
  zeptoMailIntegration.details.senders.map((sender: {name: string, email: string}, index: number) => (
    <div 
      key={`zeptomail-sender-${index}`}
      className="dropdown-item" 
      onClick={() => handleSenderSelect({
        _id: zeptoMailIntegration._id,
        email: sender.email,
        name: sender.name,
        service: 'zeptomail'
      })}
    >
      <span className="dropdown-item-email">
        {sender.name} ({sender.email})
      </span>
    </div>
  ))
}

              </>
            </div>
          )}
        </div>
      </div>
    </div>
    {validation.touched.senderDetail &&
      validation.errors.senderDetail?.email && (
        <span className="text-danger">
          {validation.errors.senderDetail.email}
        </span>
      )}
  </div>
)}
</>
)}

          {/* Step 2: Template Selection */}
          {currentStep === STEPS.TEMPLATE && (
            <div className="blockArea">
              <div className="row align-items-center">
                <div className="col-5">
                  <div className="d-flex align-items-center">
                    {(validation.values.whatsappTemplate &&
                      selectedOption === "WhatsApp") ||
                    (validation.values.emailTemplate &&
                      selectedOption === "Email") ? (
                      <img src="./assets/img/verified.png" alt="Verified" />
                    ) : (
                      <img
                        src="./assets/img/grey-ring.png"
                        alt="Not Verified"
                      />
                    )}
                    Select Template
                  </div>
                </div>
                <div className="col-7">
                  <div
                    className="fakeDropdown"
                    onClick={() => {
                      if (selectedOption === "Email") {
                        setExpandedSections((prev) => ({
                          ...prev,
                          template: !prev.template,
                        }));
                      } else {
                        setIsTemplateOpen(true);
                      }
                    }}
                    style={{ display: "flex" }}
                  >
                    <label>
                      {selectedOption === "WhatsApp"
                        ? validation.values.whatsappTemplate
                          ? selectedTemplateName
                          : "Select Template"
                        : validation.values.emailTemplate
                        ? selectedTemplateName
                        : "Select Template"}
                    </label>
                    <i
                      className={`fs-4 ri-arrow-${
                        expandedSections["template"] ? "up" : "down"
                      }-circle-line`}
                    ></i>
                  </div>
                </div>
              </div>

              {expandedSections["template"] && (
  <UnifiedTemplateSelector
    isOpen={expandedSections["template"]}
    onClose={() => {
      setExpandedSections((prev) => ({
        ...prev,
        template: false,
      }));
    }}
    onTemplateSelect={(template) => {
      if (selectedOption === "Email") {
        handleEmailTemplateSelect(template);
      } else {
        handleTemplateSelect(template);
      }
    }}
    selectedTemplateId={selectedTemplate}
    templateType={selectedOption === "Email" ? "email" : "whatsapp"}
    handleDiscard={() => {
      if (selectedOption === "Email") {
        handleDiscardEmail();
      } else {
        handleDiscard();
      }
    }}
  />
)}
            </div>
          )}

          {/* Step 3: Recipients Selection */}
          {currentStep === STEPS.RECIPIENTS && (
            <div className="blockArea">
              <div className="row align-items-center">
                <div className="col-5">
                  <div className="d-flex align-items-center">
                    {validation.values.leads.length !== 0 ? (
                      <img src="./assets/img/verified.png" alt="Verified" />
                    ) : (
                      <img
                        src="./assets/img/grey-ring.png"
                        alt="Not Verified"
                      />
                    )}
                    Select Recipients
                  </div>
                </div>
                <div className="col-7">
                  <div
                    className="fakeDropdown"
                    onClick={() => {
                      showIsLead(true);
                    }}
                    style={{ display: "flex" }}
                  >
                    <label>
                      {validation.values.leads.length !== 0 ? (
                        <>
                          {validation.values.leads.length} recipients selected
                        </>
                      ) : (
                        <>Select leads</>
                      )}
                    </label>
                    <i className="fs-4 ri-arrow-down-circle-line"></i>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 4: Schedule & Send */}
          {currentStep === STEPS.SCHEDULE && (
            <div className="blockArea">
             {/* Campaign Summary Section */}
{/* Campaign Summary */}
<div className="bg-light rounded p-4">
  <h5 className="fw-bold mb-3">Campaign Summary</h5>
  <div className="d-flex justify-content-between mb-2">
    <span className="text-muted">Campaign Type:</span>
    <span className="fw-medium">{selectedOption}</span>
  </div>
  <div className="d-flex justify-content-between mb-2">
    <span className="text-muted">Campaign Name:</span>
    <span className="fw-medium">{validation.values.name}</span>
  </div>
  <div className="d-flex justify-content-between mb-2">
    <span className="text-muted">Recipients:</span>
    <span className="fw-medium">
      {validation.values.leads.length || 0} selected
    </span>
  </div>
  {selectedOption === "Email" && (
    <div className="d-flex justify-content-between mb-2">
      <span className="text-muted">Sender:</span>
      <span className="fw-medium">
        {validation.values.senderDetail.email}
      </span>
    </div>
  )}
  {selectedOption === "WhatsApp" && (
    <div className="d-flex justify-content-between mb-2">
      <span className="text-muted">Template:</span>
      <span className="fw-medium">{selectedTemplateName}</span>
    </div>
  )}
  
  {/* Daily Email Limit - Only for Gmail and Zeptomail */}
  {selectedOption === "Email" && ["gmail", "zeptomail"].includes(validation.values.serviceType) && (
    <div className="mt-3 pt-2 border-top">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="text-muted">Daily Email Limit:</span>
        <div className="d-flex align-items-center">
        <input
  type="number"
  name="dailyLimit"
  value={validation.values.dailyLimit}
  onChange={(e) => {
    const value = parseInt(e.target.value);
    const maxValue = validation.values.leads.length;
    // Ensure value is at least 1 and at most leads.length
    validation.setFieldValue("dailyLimit", 
      !isNaN(value) ? Math.min(Math.max(1, value), maxValue) : maxValue);
  }}
  min="1"  // Changed from 0 to 1
  max={validation.values.leads.length}
  className="form-control me-2"
  style={{ width: "80px", textAlign: "center" }}
/>
          <span className="small text-muted">
            max: {validation.values.leads.length}
          </span>
        </div>
      </div>

      {/* Campaign duration information */}
      <div className="small text-muted mb-2">
  <i className="ri-information-line me-1"></i>
  {validation.values.dailyLimit >= validation.values.leads.length ? (
    <>All {validation.values.leads.length} emails will be sent at once.</>
  ) : (
    <>
      Campaign will send {validation.values.dailyLimit} emails per day and complete in 
      {" "}{Math.ceil(validation.values.leads.length / validation.values.dailyLimit)} days.
    </>
  )}
</div>
      <div className="small text-muted">
        Setting a lower daily limit can help improve email deliverability for large campaigns.
      </div>
      {validation.touched.dailyLimit && validation.errors.dailyLimit && (
        <div className="text-danger mt-1 small">
          {validation.errors.dailyLimit}
        </div>
      )}
    </div>
  )}

  {/* Email Verification Toggle - Only for Email campaigns */}
  {selectedOption === "Email" && (
    <div className="mt-3 pt-2 border-top">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <span className="text-muted">Email Verification</span>
          <div className="small text-muted mt-1">
            Verify email addresses before sending to improve deliverability
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div
            onClick={() => {
              validation.setFieldValue("isEmailVerificationEnabled", !validation.values.isEmailVerificationEnabled);
            }}
            style={{
              width: '48px',
              height: '24px',
              backgroundColor: validation.values.isEmailVerificationEnabled ? '#007bff' : '#ccc',
              borderRadius: '12px',
              position: 'relative',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              marginRight: '8px'
            }}
          >
            <div
              style={{
                width: '20px',
                height: '20px',
                backgroundColor: 'white',
                borderRadius: '50%',
                position: 'absolute',
                left: validation.values.isEmailVerificationEnabled ? '26px' : '2px',
                transition: 'left 0.2s ease',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}
            />
          </div>
          <span className="small text-muted">
            {validation.values.isEmailVerificationEnabled ? "Enabled" : "Disabled"}
          </span>
        </div>
      </div>
    </div>
  )}
</div>

{/* Action Buttons */}
<div className="d-flex justify-content-end mt-3">
  <button
    className="btn me-2"
    onClick={() => {
      setActionToConfirm("discard");
      toggleConfirmEditModal();
    }}
    style={{
      background: "none",
      border: "none",
      color: "rgba(0, 0, 0, 0.5)",
      fontWeight: "700",
      fontSize: "14px",
    }}
  >
    Discard
  </button>
  <button
    className="btn"
    onClick={() => {
      setActionToConfirm("sendNow");
      toggleConfirmEditModal();
    }}
    disabled={!isFormComplete(validation.values)}
  >
    Send Now
  </button>
  <button
    className="btn auto_btn ms-2"
    onClick={() => setIsScheduling(true)}
    disabled={!isFormComplete(validation.values)}
  >
    Schedule
  </button>
</div>

              {/* Date Selector - Visible Only When Scheduling */}
              {isScheduling && (
                <div className="mt-3">
                  <div className="row align-items-center">
                    <div className="col-5">
                      <div className="d-flex align-items-center">
                        <img src="./assets/img/verified.png" alt="Verified" />
                        Schedule Date
                      </div>
                    </div>
                    <div className="col-7">
          <input
  type="datetime-local"
  name="scheduleAt"
  min={new Date().toISOString().slice(0, 16)}
  value={validation.values.scheduleAt}
  onChange={validation.handleChange}
  className="full-click-datetime"
  placeholder=""
/>
                      {validation.touched.scheduleAt &&
                        validation.errors.scheduleAt && (
                          <div className="text-danger mt-1 small">
                            {validation.errors.scheduleAt}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Confirm Schedule Button */}
                  <div className="d-flex justify-content-end mt-3">
                    <button
                      className="btn auto_btn"
                      onClick={() => {
                        if (validation.values.scheduleAt) {
                          setActionToConfirm("schedule");
                          toggleConfirmEditModal();
                        }
                      }}
                      disabled={!validation.values.scheduleAt}
                    >
                      Confirm Schedule
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {/* Fixed Navigation Buttons */}
      {/* Fixed Navigation Buttons */}
<div className="navigation-buttons">
  <button
    className="btn"
    onClick={() => setCurrentStep((prev) => Math.max(1, prev - 1))}
    disabled={currentStep === 1}
  >
    Previous
  </button>

  {currentStep < 4 && (
    <button
      className="btn auto_btn"
      onClick={() => setCurrentStep((prev) => Math.min(4, prev + 1))}
    >
      Next
    </button>
  )}
</div>
      {/* Modals and Drawers */}
      <LeadSelector
        isOpen={isLead}
        onClose={() => showIsLead(false)}
        selectedLeads={validation.values?.leads}
        handleSelectedLeads={(leads: any) => {
          validation.setFieldValue(
            "leads",
            leads?.map((e: any) => e._id)
          );
        }}
        setSelectedLeadList={setSelectedLeadList}
        selectedLeadList={selectedLeadList}
      />
      <UnifiedTemplateSelector
  isOpen={isTemplateOpen}
  onClose={() => setIsTemplateOpen(false)}
  onTemplateSelect={(template) => {
    if (selectedOption === "Email") {
      handleEmailTemplateSelect(template);
    } else {
      handleTemplateSelect(template);
    }
  }}
  selectedTemplateId={selectedTemplate}
  templateType={selectedOption === "Email" ? "email" : "whatsapp"}
  handleDiscard={() => {
    if (selectedOption === "Email") {
      handleDiscardEmail();
    } else {
      handleDiscard();
    }
  }}
/>
      
      <DrawerExistModal
  title={
    actionToConfirm === "sendNow"
      ? "Are you sure you want to send the campaign now?"
      : actionToConfirm === "schedule"
      ? "Are you sure you want to schedule this campaign?"
      : "Are you sure you want to discard this campaign?"  // Add discard message
  }
  showExitModal={confirmShowExitModal}
  toggleEditModal={toggleConfirmEditModal}
  handleDrawerClick={handleConfirmDrawerClick}
/>
    </>
  );
};

export default CreateWhatsappBroadcast;
